import { render, staticRenderFns } from "./customerForgetRemind.vue?vue&type=template&id=7c553d1f&scoped=true"
import script from "./customerForgetRemind.vue?vue&type=script&lang=js"
export * from "./customerForgetRemind.vue?vue&type=script&lang=js"
import style0 from "./customerForgetRemind.vue?vue&type=style&index=0&id=7c553d1f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c553d1f",
  null
  
)

export default component.exports